import React from 'react';
import { Link } from "react-router-dom";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';

function WishlistPopup (props) {
  return (
    <Dialog open={true}>
      <DialogTitle>Lista preferiti</DialogTitle>
      <DialogContent>
        <p>Per accedere alla lista dei preferiti accedi o registrati su Bburago-shop!</p>
        <Link to="/login">
          <div className="accedi_popup_button">Accedi</div>
        </Link>
        <Link to="/registrazione">
          <div className="registrati_popup_button">Nuovo cliente? Registrati</div>
        </Link>
        <div
          className="chiudi_popup_button"
          onClick={(e) => props.closeHandler()}
        >
          Chiudi
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default WishlistPopup;